import NextImage from 'next/image'
import { MouseEvent, useState } from 'react'
import { getIsFirstTimeUser } from '@helpers/session/user'
import { analytics } from '@helpers/analytics'
import styles from './styles.module.scss'

const CALLOUTS = {
  '1': {
    id: '1',
    copy: 'The fabrics we’ve chosen ripple with stretch, motility, and comfort. But only when you need it — this doesn’t have the look or feel of a shiny synthetic.',
    button: {
      icon: '/static/images/enduros/asset-callout/asset-callout-high-performance-icon.svg',
      text: 'High-stretch'
    },
    event: {
      action: 'Stretch'
    },
    image:
      '/static/images/enduros/asset-callout/asset-callout-high-performance-image.gif'
  },
  '2': {
    id: '2',
    copy: 'Wear all day, and wash with careless abandon — knowing you’ll wind up with a crisp, crease-free finish. No iron needed.',
    button: {
      icon: '/static/images/enduros/asset-callout/asset-callout-low-maintenance-icon.svg',
      text: 'Low-maintenance'
    },
    event: {
      action: 'Iron'
    },
    image:
      '/static/images/enduros/asset-callout/asset-callout-low-maintenance-image.gif'
  },
  '3': {
    id: '3',
    copy: 'We dug into the details; with moisture-wicking weaves, hidden zips, low-key water-resistant finishes and reinforced pockets.',
    button: {
      icon: '/static/images/enduros/asset-callout/asset-callout-features-icon.svg',
      text: 'Smart Features'
    },
    event: {
      action: 'Smart'
    },
    image:
      '/static/images/enduros/asset-callout/asset-callout-features-image.gif'
  }
} as const

export default function AssetCallOut() {
  const [selectedCallOut, setSelectedCallOut] =
    useState<keyof typeof CALLOUTS>('1')

  const handleCallOutClick = (
    ev: MouseEvent<HTMLButtonElement>,
    id: keyof typeof CALLOUTS
  ) => {
    ev.preventDefault()
    const firstTimeUser = getIsFirstTimeUser()
    const action = CALLOUTS[id].event.action
    analytics('Click', {
      category: 'Landing Page',
      label: 'Asset Breakdown',
      action,
      type: firstTimeUser ? 'new' : 'existing'
    })
    setSelectedCallOut(id)
  }

  return (
    <div className={styles.AssetCallOut}>
      <div className={styles.AssetCallOut__content}>
        <h2 className={styles.AssetCallOut__title}>
          Packed with <br />
          <span>superpowers</span>
        </h2>
        <div className={styles.AssetCallOut__buttons}>
          {Object.values(CALLOUTS).map(callout => (
            <button
              className={`${styles.AssetCallOut__button} ${
                callout.id === selectedCallOut ? styles.selected : ''
              }`}
              onClick={ev => handleCallOutClick(ev, callout.id)}
            >
              <img
                className={styles.AssetCallOut__icon}
                src={callout.button.icon}
                alt={callout.button.text}
              />
              <p>{callout.button.text}</p>
            </button>
          ))}
        </div>
        <p className={styles.AssetCallOut__copy}>
          {CALLOUTS[selectedCallOut].copy}
        </p>
      </div>
      <NextImage
        className={styles.AssetCallOut__image}
        src={CALLOUTS[selectedCallOut].image}
        alt={CALLOUTS[selectedCallOut].button.text}
        width="720"
        height="420"
      />
    </div>
  )
}
